import React, { useContext, useEffect } from "react";
import MainContext from "../context/mainContext";
import ThemeContext from "../context/themeContext";
import parse from "html-react-parser";
import odon from "../assets/odon.png";
import mylogo from "../assets/logo0151.png";
import bpologo from "../assets/logobpo.png";
import policelogo from "../assets/LogoPolice805.png";

export default function MyHeader() {
  const ctxtheme = useContext(ThemeContext);
  const ctxmain = useContext(MainContext);
  //<img src={mylogo} height="60px" />
  //rgba(0,0,0, 0.9)
  return (
    <div
      align="center"
      style={{
        background: `rgba(0,0,107, 0.9)`,
      }}
    >
      <table>
        <tr>
          <td style={{ padding: "10px" }}>
            <img src={policelogo} height="60px" />
          </td>
          <td style={{ paddingLeft: "10px", paddingRight: "10px" }}>
            <div>{typeof ctxmain.name == "string" && parse(ctxmain.name)}</div>
          </td>
          <td></td>
        </tr>
      </table>
    </div>
  );
}
